import React, {useContext, FC} from 'react'
import {CustomerContext} from '../CustomerContext'
import {TableWrapper} from '@/components/table/TableWrapper'
import {ButtonProps, ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {Columns} from '../../../statement/list/columns/_columns'
import {Operation} from '../../../statement/core/_models'
import {getOperations} from '../../../statement/core/_requests'
import {FilterForm, initialFilters} from '../../../statement/list/components/FilterForm'
import TrxOverview from '../../../statement/list/components/TrxOverview'
import OrderOverview from '../../../statement/list/components/OrderOverview'
import ExceptionalOverview from '../../../statement/list/components/ExceptionalOverview'
import MissingCreditsForm from './forms/MissingCreditsForm'
import ReconcileBalanceForm from './forms/ReconcileBalanceForm'
import ExceptionalCreditForm from './forms/ExceptionalCreditForm'


const buttons: Array<ButtonProps> = [{
  label: 'Check balance',
  className: 'btn btn-primary me-3',
  icon: {
    name: 'arrows-circle',
    className: 'fs-2'
  },
  openModal: 'check-balance'
}, {
  label: 'Reconcile credits',
  className: 'btn btn-danger me-3',
  icon: {
    name: 'finance-calculator',
    className: 'fs-2'
  },
  openModal: 'missing-credit'
}, {
  label: 'Exceptional credits',
  className: 'btn btn-info me-3',
  icon: {
    name: 'gift',
    className: 'fs-2'
  },
  openModal: 'add-credit'

}]

const DetailsModal: FC<{type: string}> = ({type}) => {
  switch (type) {
    case 'payment':
      return <TrxOverview />;
    case 'order':
      return <OrderOverview />;
    case 'exceptional_credits':
      return <ExceptionalOverview />;
    default:
      return <></>;
  }
}


const ModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
  const op = itemForUpdate as Operation

  return (
    <>
      {!op && action === 'check-balance' && (
        <Modal title="Balance Consistency Check" maxWidth={900}>
          <ReconcileBalanceForm />
        </Modal>
      )}

      {!op && action === 'missing-credit' && (
        <Modal title="Looking for missing credits" maxWidth={900}>
          <MissingCreditsForm />
        </Modal>
      )}

      {!op && action === 'add-credit' && (
        <Modal title="Add exceptional credits" maxWidth={900}>
          <ExceptionalCreditForm />
        </Modal>
      )}
      {op && action === 'details' && (
        <Modal title="Operation details">
          <DetailsModal type={op.type} />
        </Modal>
      )}

      {op && op.parent && action === 'parent-details' && (
        <Modal title="Parent operation details">
          {op.parent.transaction ? (
            <TrxOverview />
          ) : (
            <OrderOverview />
          )}
        </Modal>
      )}
    </>
  )
}

const Overview = () => {
  const { customer } = useContext(CustomerContext)
  if (!customer) {
    return (<></>)
  }

  return (
    <TableWrapper
      dataProvider={(query: string) => getOperations(customer._id, query)}
      cols={Columns}
      queryId={`P2C_STATEMENT_${customer._id}_LIST`}
      buttons={buttons}
      modals={ModalWrapper}
      lookup={{
        placeholder: 'Search operation',
        fields: ['code']
      }}
      filters={{
        formFields: FilterForm,
        initialValues: initialFilters
      }}
    />
  )
}


export default Overview
